import React from 'react';
import { PEIImage, PEILink } from '@/common/components';
import { defaultImagePath } from '@/common';
import { parseText } from '@/utils';
import { URL } from '@/utils';
import styles from '@/styles/AboutArticlePanel.module.scss';
import { ZephrFeature } from '@/components/ZephrFeature';

const { basePEIURL } = URL;

type AboutArticlePanelItem = {
  title: string;
  thumbnail?: string;
  postName: string;
};

type AboutArticlePanelProps = {
  article: AboutArticlePanelItem;
};

export const AboutArticlePanel = ({ article }: AboutArticlePanelProps) => {
  const articleUrl = `${basePEIURL}/${article.postName}`;

  return (
    <aside className={styles.container} data-testid='about-article-panel'>
      <ZephrFeature
        placeholder={
          <div className={styles['image-wrapper']}>
            <PEIImage
              src={defaultImagePath}
              alt=''
              height={250}
              width={250}
              className={styles.image}
            />
            <div className={styles.overlay}>
              <span className={styles.title}>Sample featured story about this institution</span>
            </div>
          </div>
        }
      >
        <div className={styles['image-wrapper']}>
          <PEIImage
            src={article.thumbnail || defaultImagePath}
            alt={article.title}
            height={250}
            width={250}
            className={styles.image}
            onClick={() => {
              window.open(articleUrl);
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = defaultImagePath;
            }}
          />
          <div className={styles.overlay}>
            <PEILink href={articleUrl} target='_blank' className={styles.title}>
              {parseText(article.title)}
            </PEILink>
          </div>
        </div>
      </ZephrFeature>
    </aside>
  );
};
